export class PopUpInfoVM {
  texts!: string[];
  imgPath?: string | undefined;

  constructor(texts: string[], imgPath?: string) {
    this.texts = texts;
    this.imgPath = imgPath;
  }
}

export class PopUpInfoHAVM {
  texts!: string[];

  constructor(texts: string[]) {
    this.texts = texts;
  }
}
